<template>
  <div class="container-fluid">
    <template v-for="(disc, discId) in possibleItems.list">
      <div
        v-if="metalsFound(discId)"
        class="row border-bottom"
        v-bind:key="discId"
      >
        <div class="col-9" @click="editDisc = discId">
          <h5 v-if="isAlloyCombi !== true">
            {{ $tc("Common.ringLayout." + ringLayout, discId + 1) }}
          </h5>
          <h5 v-else>{{ $t("Common.jewelleryType.0") }}</h5>
          <p class="text-start" v-if="editDisc !== discId">{{ disc.text }}</p>
        </div>
        <div class="col-3 text-end">
          <img
            :src="appUrl + '/img/icons/edit.svg'"
            class="icon open"
            v-if="editDisc !== discId"
            @click="editDisc = discId"
            alt="edit"
          />
          <img
            :src="appUrl + '/img/icons/close.svg'"
            class="icon"
            v-if="editDisc === discId"
            @click="closeDisc"
            alt="close"
          />
        </div>
        <div class="col-12" v-if="editDisc === discId">
          <template v-if="itemResult === null">
            <ul class="colors">
              <template v-for="(item, index) in metalList">
                <li
                  v-bind:key="index"
                  @click="useResult(item)"
                  :class="{ match: item.match }"
                >
                  <img
                    @error="
                      $parent.setIconNotAvailable(
                        $refs['metals_disc' + index + '_' + item.color]
                      )
                    "
                    :ref="'metals_disc' + index + '_' + item.color"
                    :src="
                      isAlloyCombi !== true && item.color
                        ? appUrl +
                          '/img/assets/colors/a_' +
                          item.color.toLowerCase() +
                          '.jpg'
                        : $parent['getFinishIcon'](
                            '',
                            '',
                            item.result[item['firstKey']].itemnumber,
                            false
                          )
                    "
                    :srcset="
                      isAlloyCombi !== true && item.color
                        ? appUrl +
                          '/img/assets/colors/a_' +
                          item.color.toLowerCase() +
                          '@2x.jpg'
                        : $parent['getFinishIcon'](
                            '',
                            '',
                            item.result[item['firstKey']].itemnumber,
                            true
                          )
                    "
                    :alt="item.text"
                    class="thumb"
                  />
                  <p>
                    <span>
                      {{ item.text }}
                      <br/>
                      <template v-if="item.number > 1">
                        {{ $t("Menu.list.metals.priceFrom") }}
                      </template>
                      <template>
                        {{
                          $n(
                            getPriceForAll(item.result[item["firstKey"]]),
                            "currency"
                          )
                        }}
                      </template>
                    </span>
                  </p>
                </li>
              </template>
              <li v-if="!allMetals" @click="allMetals = true">
                <img
                  :src="appUrl + '/img/icons/next.svg'"
                  alt="more"
                  class="thumb"
                />
                {{ $t("Menu.list.metals.next") }} &gt;
              </li>
            </ul>
          </template>
          <template v-else>
            <div class="row">
              <div class="col-12">
                <p style="margin-top: 1rem">
                  {{ $t("Menu.list.metals.infoAlert") }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 metal-list">
                <ul>
                  <li
                    v-for="(item, index) in itemResult"
                    v-bind:key="index"
                    @click="changeItem(item.itemnumber)"
                  >
                    <img
                      v-for="color in item.colors"
                      v-bind:key="color"
                      @error="
                        $parent.setIconNotAvailable(
                          $refs['metals_disc' + index + '_' + color]
                        )
                      "
                      :ref="'metals_disc' + index + '_' + color"
                      :src="
                        appUrl +
                        '/img/assets/colors/a_' +
                        color.toLowerCase() +
                        '.jpg'
                      "
                      :srcset="
                        appUrl +
                        '/img/assets/colors/a_' +
                        color.toLowerCase() +
                        '@2x.jpg'
                      "
                      :alt="item.text"
                      class="thumb"
                    />
                    <p v-html="addLineBreaks(item.text)"></p>
                    <p>{{ $n(getPriceForAll(item), "currency") }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";

export default {
  name: "VariationsMetals",
  props: ["possibleItems"],
  data() {
    return {
      appUrl: Config.getters.getAppUrl,
      editDisc: 0,
      allMetals: true,
      ringLayout: SetData.getters.getRingLayout,
      itemResult: null,
      maxItems: 99,
    };
  },
  methods: {
    closeDisc: function () {
      if (this.itemResult != null) {
        this.itemResult = null;
      } else {
        this.editDisc = false;
      }
    },
    changeItem: function (itemnumber, alerts) {
      this.$parent.$parent.changeItem(itemnumber, alerts);
      this.itemResult = null;
    },
    useResult: function (itemData) {
      if (itemData.number > 1) {
        this.itemResult = itemData.result;
      } else {
        this.changeItem(itemData.result[itemData.firstKey].itemnumber);
      }
    },
    configure: function (type) {
      this.$root.$emit("configure", type);
    },
    addLineBreaks: function (text) {
      text = text.replaceAll("/--", "/-");
      text = text.replaceAll("/-", "/-<br/>");
      return text;
    },
    metalsFound: function (discId) {
      if (typeof this.possibleItems.list[discId] === "object") {
        if (this.possibleItems.list[discId].list.length === 0) {
          return false;
        }
      }
      return true;
    },
    getPriceForAll: function (itemData) {
      let priceSum = 0;
      if (this.possibleItems && this.possibleItems["singlePrices"]) {
        if (
          typeof itemData === "object" &&
          itemData.itemnumber &&
          itemData.itemnumber.length > 1
        ) {
          for (let i in itemData.itemnumber) {
            if (
              !isNaN(this.possibleItems["singlePrices"][itemData.itemnumber[i]])
            ) {
              priceSum +=
                this.possibleItems["singlePrices"][itemData.itemnumber[i]];
            }
          }
        }
      }
      return priceSum === 0 ? itemData.price : priceSum;
    },
  },
  updated() {
    if (this.possibleItems.list.length === 1) {
      this.editDisc = 0;
    }
  },
  computed: {
    isAlloyCombi() {
      return this.$parent.$parent.$parent["isCurrentItemAlloyCombi"](
        SetData.getters.getCurrentItemId
      );
    },
    metalList: function () {
      let list = {};

      if (typeof this.possibleItems.list[this.editDisc] === "object") {
        let counter = 0;

        for (let key in this.possibleItems.list[this.editDisc].list) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.possibleItems.list[this.editDisc].list,
              key
            )
          ) {
            if (this.allMetals === true || counter < this.maxItems) {
              list[key] = this.possibleItems.list[this.editDisc].list[key];
              counter++;
            }
          }
        }
      }

      return list;
    },
  },
  watch: {
    editDisc: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (this.editDisc !== false) {
            let length = Object.keys(
              this.possibleItems.list[this.editDisc].list
            ).length;
            this.allMetals = length <= this.maxItems + 2;
          } else {
            this.allMetals = true;
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  h5,
  p {
    cursor: pointer;
  }

  .metal-list {
    overflow: auto;

    ul {
      list-style: none;
      padding: 0;
      margin: 1em 0 0 0;
      width: max-content;

      li {
        list-style: none;
        margin: 0;
        padding: 0 1em 1em 1em;
        display: inline-block;
        width: 10em;
        vertical-align: top;
        cursor: pointer;

        img.thumb {
          height: 3em;
          width: auto;
          display: inline-block;
          margin: 0.1em;
        }
      }
    }
  }

  ul.colors {
    text-align: center;
    padding: 0;
    margin: 1em 0 0 0;

    li {
      display: inline-flex;
      overflow: hidden;
      padding: 1.5rem 0 1.5rem 0;
      margin: 0.75rem 0;
      border: none;
      vertical-align: top;
      cursor: pointer;
      align-items: center;
      text-align: left;
      width: 100%;
      border-bottom: 0.1rem solid #ccc;

      &:last-child {
        border-bottom: none;
      }

      img {
        height: auto;
        align-items: center;
        display: inline-flex;
      }

      p {
        margin: 0 0 0 0;
        padding-left: 1.5rem;
        font-size: 1.6rem;
        display: inline-flex;

        span {
          display: inline-flex;
        }
      }
    }

    li.match {
      font-weight: bold;
      background-color: inherit;
      color: $black;

      img {
        border: solid 0.2rem $brandGold;
      }
    }
  }
}
</style>
